import { Component } from "@angular/core";

@Component({
  templateUrl: "./account-deletion.component.html",
  styleUrls: ["../privacy/privacy.css", "./account-deletion.component.css"]
})
export class AccountDeletionComponent {}
